var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.456,
    height: 16.583,
    viewBox: "0 0 23.456 16.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.235,565.038l-19.663-.188a1.737,1.737,0,0,1-1.718-1.753l.123-12.722a1.737,1.737,0,0,1,1.751-1.719l19.663.19a1.737,1.737,0,0,1,1.719,1.751l-.123,12.724A1.737,1.737,0,0,1,290.235,565.038Zm-19.518-15.226a.577.577,0,0,0-.583.573l-.124,12.724a.58.58,0,0,0,.574.584l19.663.188a.578.578,0,0,0,.584-.573l.123-12.722a.58.58,0,0,0-.573-.584Z",
    transform: "translate(-268.855 -548.656)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.277,559.673h0l-4.917-.047a.492.492,0,0,1-.487-.5,2.512,2.512,0,0,1,.393-1.24,3.321,3.321,0,0,1,5.136.05,2.563,2.563,0,0,1,.371,1.209c0,.012,0,.025,0,.037A.491.491,0,0,1,277.277,559.673Zm-4.3-1.025,3.7.035a1.562,1.562,0,0,0-.135-.264,2.4,2.4,0,0,0-3.428-.032A1.4,1.4,0,0,0,272.977,558.648Z",
    transform: "translate(-268.523 -547.017)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.334,553.784l-4.916-.048a.492.492,0,0,1,.01-.983l4.916.048a.492.492,0,0,1-.01.983Z",
    transform: "translate(-266.666 -547.957)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.332,555.774l-3.933-.038a.492.492,0,1,1,.01-.983l3.932.039a.492.492,0,1,1-.009.983Z",
    transform: "translate(-266.851 -547.617)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.313,557.774l-3.933-.038a.492.492,0,0,1,.009-.983l3.933.038a.492.492,0,0,1-.009.983Z",
    transform: "translate(-266.855 -547.276)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.874,555.632a1.967,1.967,0,1,1,1.985-1.947A1.968,1.968,0,0,1,274.874,555.632Zm.029-2.95a.983.983,0,1,0,.973.993A.985.985,0,0,0,274.9,552.682Z",
    transform: "translate(-268.405 -547.972)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.276,559.783l-4.916-.047a.492.492,0,0,1,.01-.983l4.917.047a.492.492,0,0,1-.01.983Z",
    transform: "translate(-266.679 -546.934)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNif);
export default __webpack_public_path__ + "static/media/nif.990812b875b2e0a66e24d9d402e1648c.svg";
export { ForwardRef as ReactComponent };